import { isData } from "utils/HookResponse";
import { useFetchData } from "utils/ReactQueryHooks";
import { STALE } from "constants/stale";
import { ApiResponseData } from "types/common";

export const useDeviceCodes = () =>
  useFetchData({
    key: "deviceCodes",
    url: "device-codes",
    options: {
      select: (data: ApiResponseData) => isData(data),
      staleTime: STALE.MEDIUM,
    },
  });